// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__vxVBc","large":"styles_large__3-oaC"};